var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "p-3 bg-secondary-1", class: _vm.isMobile && "row" },
    [
      _c("div", { staticClass: "bg-secondary-1 col-12" }, [
        _c(
          "div",
          { staticClass: "row hoursRow pt-2 px-0 align-items-center" },
          [
            _c(
              "div",
              {
                staticClass: "border-right",
                class: {
                  "col-1": !_vm.isMobile,
                  "col-4": _vm.isMobile
                }
              },
              [
                _c(
                  "span",
                  { staticClass: "color-red-orange font-weight-bold hourSpan" },
                  [_vm._v(" Horario ")]
                )
              ]
            ),
            _c(
              "div",
              {
                class: {
                  "col-11": !_vm.isMobile,
                  "col-8 scroll-h": _vm.isMobile
                }
              },
              [
                _c(
                  "div",
                  { staticClass: "d-flex" },
                  [
                    _vm.options.length > 0
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "d-inline border py-2 px-3 mr-2 font-14 filter-selection-tag",
                            class: {
                              "filter-selected": _vm.hoursSelected === "Todos"
                            },
                            on: {
                              click: function($event) {
                                return _vm.onSelectAll()
                              }
                            }
                          },
                          [_vm._v(" Todos ")]
                        )
                      : _vm._e(),
                    _vm._l(_vm.options, function(hour) {
                      return _c(
                        "div",
                        {
                          key: hour.label,
                          staticClass:
                            "d-inline border py-2 px-3 mr-2 font-14 filter-selection-tag",
                          class: {
                            "filter-selected": _vm.hoursSelected === hour
                          },
                          on: {
                            click: function($event) {
                              return _vm.onSelectHours(hour)
                            }
                          }
                        },
                        [_vm._v(" " + _vm._s(hour.label) + " ")]
                      )
                    })
                  ],
                  2
                )
              ]
            )
          ]
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }